import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Inbox, Clock, ChevronRight } from 'lucide-react';
import { db } from "../firebase";
import { ref, onValue } from "firebase/database";
import './History.css';

const History = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('Deposit'); 
    const [filter, setFilter] = useState('All'); 
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);

    const savedUser = JSON.parse(localStorage.getItem('user'));

    // Tab switch hote hi filter set karna
    useEffect(() => {
        if (activeTab === 'Trade') {
            setFilter('Success'); 
        } else {
            setFilter('All');
        }
    }, [activeTab]);

    useEffect(() => {
        if (savedUser?.username) {
            setLoading(true);
            
            let paths = [];
            if (activeTab === 'Deposit') {
                paths = ['depositRequests', 'depositHistory'];
            } else if (activeTab === 'Withdraw') {
                paths = ['withdrawalRequests', 'withdrawals'];
            } else {
                // Trade ke liye sirf transactions node jahan ActiveTrades data bhejta hai
                paths = ['transactions'];
            }

            const fetchAllData = () => {
                let combinedData = [];
                let completedListeners = 0;

                paths.forEach((path) => {
                    const historyRef = ref(db, path);
                    onValue(historyRef, (snapshot) => {
                        const data = snapshot.val();
                        if (data) {
                            const list = Object.values(data).filter(item => item.username === savedUser.username);
                            combinedData = [...combinedData, ...list];
                        }

                        completedListeners++;
                        if (completedListeners === paths.length) {
                            const filteredList = combinedData
                                .filter(item => {
                                    // Trade tab par sirf completed trades dikhani hain
                                    if (activeTab === 'Trade') {
                                        return item.type === 'Trade';
                                    }
                                    
                                    if (filter === 'All') return true;
                                    
                                    const itemStatus = item.status?.toLowerCase();
                                    const filterStatus = filter.toLowerCase();
                                    return itemStatus === filterStatus;
                                })
                                .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));

                            setRecords(filteredList);
                            setLoading(false);
                        }
                    });
                });
            };

            fetchAllData();
        }
    }, [activeTab, filter, savedUser?.username]);

    return (
        <div className="white-history-container">
            <div className="white-history-header">
                <ArrowLeft onClick={() => navigate(-1)} className="back-btn-white" />
                <h3>Transaction History</h3>
                <div className="header-icon-white">
                    <Clock size={20} />
                </div>
            </div>

            <div className="history-main-layout-white">
                <div className="history-left-sidebar-white">
                    {['Deposit', 'Withdraw', 'Trade'].map((tab) => (
                        <div 
                            key={tab}
                            className={`side-tab-white ${activeTab === tab ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                            {activeTab === tab && <div className="active-indicator-white" />}
                        </div>
                    ))}
                </div>

                <div className="history-right-content-white">
                    <div className="status-filter-bar-white">
                        {activeTab === 'Trade' ? (
                            <button className="filter-btn-white active">Completed</button>
                        ) : (
                            ['All', 'Pending', 'Success', 'Rejected'].map((s) => (
                                <button 
                                    key={s}
                                    className={`filter-btn-white ${filter === s ? 'active' : ''}`}
                                    onClick={() => setFilter(s)}
                                >
                                    {s === 'Success' ? 'Completed' : s}
                                </button>
                            ))
                        )}
                    </div>

                    <div className="records-scroll-area-white">
                        {loading ? (
                            <div className="loader-box-white">Loading...</div>
                        ) : records.length === 0 ? (
                            <div className="empty-state-white">
                                <Inbox size={50} strokeWidth={1} color="#ccd0d5" />
                                <p>No {activeTab} records found</p>
                            </div>
                        ) : (
                            records.map((item, index) => (
                                <div key={index} className="transaction-card-white">
                                    <div className="card-top-white">
                                        <span className="asset-name-white">
                                            {activeTab === 'Trade' ? item.pair : (item.currency || 'USDT')}
                                        </span>
                                        <span className={`status-badge-white ${item.status?.toLowerCase() === 'success' ? 'success' : item.status?.toLowerCase() || 'pending'}`}>
                                            {item.status === 'Success' ? 'Completed' : item.status || 'Pending'}
                                        </span>
                                    </div>
                                    <div className="card-mid-white">
                                        <div className="amount-group-white">
                                            <span className="label-white">{activeTab === 'Trade' ? 'Profit/Loss' : 'Amount'}</span>
                                            <span className="value-white" style={{ color: activeTab === 'Trade' && item.amount >= 0 ? '#0ecb81' : activeTab === 'Trade' ? '#f6465d' : '#1e2329' }}>
                                                {item.amount >= 0 && activeTab === 'Trade' ? `+${parseFloat(item.amount).toFixed(2)}` : parseFloat(item.amount).toFixed(2)} USDT
                                            </span>
                                        </div>
                                        <div className="date-group-white">
                                            <span className="label-white">Date</span>
                                            <span className="value-white">
                                                {item.timestamp ? new Date(item.timestamp).toLocaleDateString() : '---'}
                                            </span>
                                        </div>
                                        <ChevronRight size={18} color="#94a3b8" />
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default History;